export default __webpack_public_path__ + "static/media/1767.e200201c.png";